import type {
    ClearCommerceStorefrontRequest,
    ClearCommerceStorefrontResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";

export const clearCommerceStorefrontOperation: CommerceOperation<
    ClearCommerceStorefrontRequest,
    ClearCommerceStorefrontResponse
> = Object.freeze({ name: "commerce.storefront.clear" });
